/** Optional customer wishlist adapter. Read before CAS writes; uncertain writes are never retried automatically. */
(function (host, factory) {
  'use strict';
  var api = factory(typeof module === 'object' && module.exports ? require('./pg-wishlist.js') : host.PGWishlist);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (host && host.document) api.boot(host);
})(typeof window !== 'undefined' ? window : globalThis, function (core) {
  'use strict';
  var SESSION_KEY = 'pg:wish:session';
  function proxyPath(value) { return typeof value === 'string' && /^\/apps\/[a-z0-9][a-z0-9_-]{0,79}\/wishlist$/.test(value) ? value : null; }
  function customerId(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    value = String(value).replace(/^gid:\/\/shopify\/Customer\//, '');
    return /^[1-9][0-9]{0,19}$/.test(value) ? value : null;
  }
  function validateResponse(body, id, write) {
    if (body && customerId(body.customer_id) && customerId(body.customer_id) !== id) throw new Error('identity');
    if (!body || customerId(body.customer_id) !== id || body.customer_id !== 'gid://shopify/Customer/' + id ||
      !core.validList(body.handles) || core.clean(body.handles).length !== body.handles.length || body.limit !== 100 ||
      !(body.revision === null || (typeof body.revision === 'string' && body.revision.length > 0 && body.revision.length <= 1024)) ||
      typeof body.write_token !== 'string' || body.write_token.length < 20 || body.write_token.length > 4096 || /[\u0000-\u0020]/.test(body.write_token) ||
      (write && body.ok !== true)) throw new Error('invalid_response');
    return { handles: body.handles.slice(), revision: body.revision, writeToken: body.write_token };
  }
  function same(a, b) { return JSON.stringify(a) === JSON.stringify(b); }
  function create(options) {
    var id = customerId(options.customerId);
    var endpoint = proxyPath(options.endpoint);
    if (!id || !endpoint) return null;
    var store = options.store;
    var timers = options.timers || globalThis;
    var pendingKey = 'pg:wish:pending:' + id;
    var operations = new Map();
    var serial = 0;
    var base = [];
    var revision = null;
    var writeToken = null;
    var ready = false;
    var disposed = false;
    var writing = false;
    var reading = null;
    var needsConfirmation = false;
    var problem = null;
    var status = 'loading';
    var controllers = new Set();
    var unsubscribe = null;
    try {
      var saved = JSON.parse(options.sessionStorage.getItem(pendingKey) || 'null');
      if (saved && Array.isArray(saved.operations) && saved.operations.length <= 2000 && saved.operations.every(function (item) { return core.validHandle(item.handle) && typeof item.present === 'boolean'; })) {
        saved.operations.forEach(function (item) { operations.set(item.handle, { present: item.present, serial: ++serial }); });
        needsConfirmation = operations.size > 0;
        if (needsConfirmation) problem = 'unconfirmed';
      }
    } catch (_) { /* This tab still retains new intent in memory when session storage is unavailable. */ }
    function persist() {
      try { options.sessionStorage.setItem(pendingKey, JSON.stringify({ operations: Array.from(operations, function (entry) { return { handle: entry[0], present: entry[1].present }; }) })); } catch (_) {}
    }
    function current() {
      return !disposed && store.currentScope() === id && (!options.isSessionCurrent || options.isSessionCurrent());
    }
    function report(value) {
      if (disposed) return;
      status = value;
      if (options.onState) options.onState({ status: value, pending: operations.size, customerId: id });
    }
    function stop(lock) {
      if (disposed) return;
      persist(); disposed = true; controllers.forEach(function (controller) { controller.abort(); });
      if (unsubscribe) unsubscribe();
      if (lock !== false) store.lock();
    }
    function desired() {
      var list = base.slice();
      operations.forEach(function (operation, handle) {
        var index = list.indexOf(handle);
        if (!operation.present && index >= 0) list.splice(index, 1);
        if (operation.present && index < 0) list.push(handle);
      });
      return list;
    }
    function display() {
      var list = desired();
      if (list.length > core.LIMIT) { needsConfirmation = true; problem = 'limit'; report('limit'); return false; }
      store.write(list, { source: 'remote' });
      return true;
    }
    function satisfied() {
      operations.forEach(function (operation, handle) {
        if ((base.indexOf(handle) >= 0) === operation.present) operations.delete(handle);
      });
      persist();
    }
    async function request(method, body) {
      if (!current()) throw new Error('session');
      var controller = new (options.AbortController || AbortController)();
      controllers.add(controller);
      var timeout = timers.setTimeout(function () { controller.abort(); }, 12000);
      try {
        var init = { method: method, credentials: 'same-origin', mode: 'same-origin', redirect: 'error', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal };
        if (method === 'POST') { init.headers = { 'Content-Type': 'application/json' }; init.body = JSON.stringify(body); }
        var response = await options.fetch(endpoint, init);
        if (!current()) throw new Error('session');
        if (!response.ok) { var error = new Error(response.status === 401 ? 'auth' : response.status === 403 ? 'expired' : response.status === 409 ? 'conflict' : response.status === 503 ? 'unavailable' : 'request'); error.status = response.status; throw error; }
        var data = validateResponse(await response.json(), id, method === 'POST');
        if (!current()) throw new Error('session');
        return data;
      } finally { timers.clearTimeout(timeout); controllers.delete(controller); }
    }
    async function readServer(reason) {
      if (!current() || writing) return false;
      if (reading) return reading;
      report('loading');
      reading = (async function () {
        try {
          var result = await request('GET');
          base = result.handles; revision = result.revision; writeToken = result.writeToken; ready = true;
          satisfied();
          if (!display()) return false;
          if (!operations.size) { needsConfirmation = false; problem = null; report('saved'); }
          else if (reason === 'retry') { needsConfirmation = false; problem = null; report('pending'); }
          else report(needsConfirmation ? problem || 'unconfirmed' : 'pending');
          return true;
        } catch (error) {
          if (!current()) return false;
          if (error.message === 'identity') { report('session'); stop(); return false; }
          ready = false; needsConfirmation = true;
          problem = error.message === 'auth' ? 'auth' : error.message === 'unavailable' ? 'unavailable' : 'offline';
          report(problem); return false;
        } finally { reading = null; }
      })();
      return reading;
    }
    async function flush() {
      if (!current() || !ready || writing || reading || needsConfirmation || !operations.size) return;
      var list = desired();
      if (list.length > core.LIMIT) { needsConfirmation = true; problem = 'limit'; report('limit'); return; }
      var snapshot = new Map(operations);
      writing = true; report('saving');
      try {
        var result = await request('POST', { handles: list, revision: revision, write_token: writeToken });
        if (!same(result.handles, list)) throw new Error('invalid_response');
        base = result.handles; revision = result.revision; writeToken = result.writeToken;
        snapshot.forEach(function (operation, handle) { if (operations.has(handle) && operations.get(handle).serial === operation.serial) operations.delete(handle); });
        persist(); display(); report(operations.size ? 'pending' : 'saved');
      } catch (error) {
        if (!current()) return;
        if (error.message === 'identity') { report('session'); stop(); return; }
        needsConfirmation = true;
        problem = error.message === 'conflict' ? 'conflict' : error.message === 'auth' ? 'auth' : error.message === 'expired' ? 'expired' : error.message === 'unavailable' ? 'unavailable' : 'unconfirmed';
        report(problem);
      } finally { writing = false; }
      if (!current()) return;
      if (needsConfirmation) {
        if (problem === 'conflict' || problem === 'unconfirmed' || problem === 'expired') await readServer('reconcile');
      } else if (operations.size) await flush();
    }
    store.useScope(id);
    unsubscribe = store.subscribe(function (detail) {
      if (!current()) return;
      if (detail.source === 'external') { if (!writing) readServer('external').then(function (ok) { if (ok) flush(); }); return; }
      if (detail.source !== 'local' || detail.error === 'limit' || detail.error === 'session') return;
      var previous = detail.previous || [];
      var next = detail.list;
      previous.forEach(function (handle) { if (next.indexOf(handle) < 0) operations.set(handle, { present: false, serial: ++serial }); });
      next.forEach(function (handle) { if (previous.indexOf(handle) < 0) operations.set(handle, { present: true, serial: ++serial }); });
      persist(); report(needsConfirmation ? problem || 'unconfirmed' : 'pending');
      flush();
    });
    return {
      start: async function () { if (await readServer('start')) await flush(); },
      retry: async function () { if (await readServer('retry')) await flush(); },
      refresh: async function () { if (await readServer('external')) await flush(); },
      state: function () { return { status: status, pending: operations.size, revision: revision }; },
      dispose: stop
    };
  }

  function boot(win) {
    var doc = win.document;
    var configNode = doc.querySelector('[data-pg-wishlist-sync-config]');
    if (!configNode || configNode.hasAttribute('data-ready')) return;
    configNode.setAttribute('data-ready', '');
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    if (!config || config.enabled !== true || !win.PGWishlist) return;
    var store = win.PGWishlist;
    var id = customerId(config.customer_id);
    var identity = id || 'guest';
    var storage;
    try { storage = win.localStorage; storage.setItem(SESSION_KEY, identity); } catch (_) { store.lock('storage'); return; }
    if (!id) { if (config.customer_id !== null) store.lock(); else store.useScope(null); return; }
    var panel = doc.querySelector('[data-pg-wishlist-sync-panel]');
    var copy = config.copy || {};
    var pendingImport = [];
    var decisionKey = 'pg:wish:import:' + id;
    var showImport = false;
    try { pendingImport = core.parseStored(storage.getItem(core.KEY) || '[]'); showImport = pendingImport.length > 0 && !storage.getItem(decisionKey); } catch (_) {}
    var nodes = {};
    if (panel) ['status', 'retry', 'reload', 'import', 'list', 'accept', 'skip'].forEach(function (name) { nodes[name] = panel.querySelector('[data-pg-wishlist-sync-' + name + ']'); });
    function setState(state) {
      if (!panel) return;
      nodes.status.textContent = copy[state.status] || copy.offline || '';
      nodes.retry.hidden = ['offline', 'unconfirmed', 'conflict', 'limit', 'auth', 'unavailable', 'expired'].indexOf(state.status) < 0;
      nodes.retry.textContent = copy[state.status === 'conflict' ? 'merge_retry' : 'retry'] || '';
      nodes.retry.disabled = state.status === 'loading' || state.status === 'saving';
      nodes.accept.disabled = ['loading', 'auth', 'unavailable', 'session'].indexOf(state.status) >= 0;
      nodes.reload.hidden = state.status !== 'session';
      panel.hidden = !showImport && (state.status === 'saved' || state.status === 'loading') && !doc.querySelector('[data-pg-wishlist]');
    }
    if (panel) {
      nodes.reload.addEventListener('click', function () { win.location.reload(); });
      nodes.import.hidden = !showImport;
      pendingImport.forEach(function (handle) { var item = doc.createElement('li'); item.textContent = handle.replace(/-/g, ' '); nodes.list.appendChild(item); });
      function dismissImport(value) { showImport = false; nodes.import.hidden = true; try { storage.setItem(decisionKey, value); } catch (_) {} }
      nodes.skip.addEventListener('click', function () { dismissImport('kept'); if (controller) setState(controller.state()); });
      nodes.accept.addEventListener('click', function () {
        var result = store.importList(pendingImport, 'merge');
        if (result.ok) dismissImport('imported');
        else setState({ status: result.error === 'limit' ? 'limit' : 'offline' });
      });
    }
    var sessionStorage;
    try { sessionStorage = win.sessionStorage; } catch (_) { sessionStorage = null; }
    var controller = create({ store: store, customerId: id, endpoint: config.endpoint, fetch: win.fetch.bind(win), sessionStorage: sessionStorage, AbortController: win.AbortController, timers: win,
      isSessionCurrent: function () { try { return storage.getItem(SESSION_KEY) === identity; } catch (_) { return false; } }, onState: setState });
    if (!controller) { store.lock(); setState({ status: 'unavailable' }); if (nodes.retry) nodes.retry.hidden = true; if (nodes.reload) nodes.reload.hidden = false; return; }
    if (nodes.retry) nodes.retry.addEventListener('click', function () { controller.retry(); });
    function invalidate() { controller.dispose(); setState({ status: 'session' }); if (nodes.retry) nodes.retry.hidden = true; }
    win.addEventListener('storage', function (event) {
      if (event.key === SESSION_KEY || event.key === null) {
        try { if (storage.getItem(SESSION_KEY) !== identity) invalidate(); } catch (_) { invalidate(); }
      }
    });
    win.addEventListener('pagehide', function () { controller.dispose(); });
    win.addEventListener('pageshow', function (event) { if (event.persisted) { invalidate(); } });
    controller.start();
  }
  return { SESSION_KEY: SESSION_KEY, customerId: customerId, proxyPath: proxyPath, validateResponse: validateResponse, create: create, boot: boot };
});
